import { SidebarFeatureEnum } from 'config/types/sidebar'
import { Suspense, lazy, useMemo } from 'react'

const TournamentNoticeBadge = lazy(() => import('./TournamentNoticebadge'))

const NoticeBadge = ({ feature }: { feature: SidebarFeatureEnum }) => {
  const badge = useMemo(() => {
    if (feature === SidebarFeatureEnum.Tournament) {
      return <TournamentNoticeBadge />
    }

    // Add more features here
    return null
  }, [feature])

  return <Suspense fallback={null}>{badge}</Suspense>
}

export default NoticeBadge
